/* Sticky-Kaufleiste

   Blendet eine schmale Leiste mit Preis, Variante und Kaufbutton ein, sobald
   der Hero-Kaufbereich aus dem Blick gescrollt ist. Spiegelt Auswahl und Menge
   in beide Richtungen, damit beide Formulare denselben Stand zeigen.

   Faellt bewusst still aus, wenn IntersectionObserver fehlt oder der Hero-
   Kaufbereich nicht gefunden wird — dann bleibt die Seite wie bisher. */

(function () {
  'use strict';

  function init(bar) {
    if (!bar || bar.dataset.stickyBuyReady === 'true') return;
    bar.dataset.stickyBuyReady = 'true';

    var watchSelector = bar.dataset.watch;
    var watched = watchSelector ? document.querySelector(watchSelector) : null;
    if (!watched || typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('sticky-buy--visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '-72px 0px 0px 0px', threshold: 0 }
    );

    observer.observe(watched);

    /* Variantenauswahl spiegeln: Leiste -> Hero */
    var barSelect = bar.querySelector('[data-sticky-buy-variant]');
    var heroSelects = document.querySelectorAll(
      '.produktinformationen-v2 select[name="options[Size]"], .produktinformationen-v2 select'
    );

    if (barSelect && heroSelects.length) {
      barSelect.addEventListener('change', function () {
        heroSelects.forEach(function (sel) {
          if (sel === barSelect) return;
          if (sel.value === barSelect.value) return;
          sel.value = barSelect.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      /* und zurueck: Hero -> Leiste */
      heroSelects.forEach(function (sel) {
        if (sel === barSelect) return;
        sel.addEventListener('change', function () {
          if (barSelect.value !== sel.value) barSelect.value = sel.value;
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-sticky-buy]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
